(function () {
  try {
    if (window.__salepifyPagetifyPlacement) return;
    window.__salepifyPagetifyPlacement = true;

    var PLACEMENTS = ['salepify-product-bundle-placement', 'salepify-volume-discount-placement'];
    var ANCHOR = '.pe-product-cart-button';

    function place() {
      var anchors = document.querySelectorAll(ANCHOR);
      if (!anchors.length) return false;
      // Pagetify dựng 2 bản desktop/mobile (1 bản bị ẩn) → chèn cho từng nút
      anchors.forEach(function (anchor) {
        var ref = anchor.closest('.pe-pirate') || anchor; // ra ngoài flex container
        if (ref.getAttribute('data-sp-placed')) return;
        ref.setAttribute('data-sp-placed', '1');
        PLACEMENTS.forEach(function (cls) {
          var el = document.createElement('div');
          el.className = cls;
          el.style.cssText = 'width:100%;margin-top:12px;clear:both';
          ref.insertAdjacentElement('afterend', el);
          ref = el;
        });
      });
      return true;
    }

    if (place()) return;
    var mo = new MutationObserver(function () {
      try {
        if (place()) mo.disconnect();
      } catch (e) {
        mo.disconnect();
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 10000);
  } catch (e) {}
})();
